<ion-button (click)="makePayment()" class="ion-text-uppercase status-btn">
  <ion-icon
    name="checkmark"
    class="ion-float-left icon-padding"
    color="light"
  ></ion-icon>
  {{ tradeType === "S" ? "RECEIVE PAYMENT" : "MAKE PAYMENT" }}</ion-button
>
